// extracted by mini-css-extract-plugin
export default {"container":"styles_container__xcWc6","total":"styles_total__3v-ts","item":"styles_item__auTrD","search":"styles_search__eTBux"};